import { useState, useEffect } from 'react';
import { getActivities, addActivity, deleteActivity, clearAllActivities, updateActivity } from '../firebase/activityService';
import AddActivityForm from './AddActivityForm';
import Modal from './Modal';
import VideoModal from './VideoModal';
import Header from './Header';

const originalActivities = [
  {
    ActivityName: "Warm up",
    SkillTags: "Dribbling, Warm-up",
    Instructions: "Set up hat cones in the middle of the court (24 to include coaches) Bounce to the beat – 'Mambo No. 5' (Karla to lead)",
    VideoURL: ""
  },
  {
    ActivityName: "Jail Break",
    SkillTags: "Defence",
    Instructions: "Encourage eyes up to look for defenders. Divide teams into 2 teams of 4. One team is defence (stands on the 3-point line), second team is offence (stands at baseline). Offensive team needs to push past the defensive team.",
    VideoURL: "https://www.youtube.com/watch?v=IpnMNqJ5diA"
  },
  {
    ActivityName: "Chicken & the Fox",
    SkillTags: "Defence, Dribbling, Footwork, Passing, Shooting",
    Instructions: "Encourage heads up to remain alert and avoid collisions. Divide team into 3 groups of 2 or 3. One player is the fox, second/third player is the chicken. Round 1: Fox chases chicken around circle (no ball). Round 2: Chicken dribbles while being chased. Round 3: Both players dribble.",
    VideoURL: "https://www.youtube.com/watch?v=yRf8kyykh-8"
  },
  {
    ActivityName: "Alley Hoops",
    SkillTags: "Defence, Dribbling, Shooting",
    Instructions: "Divide students into 4 pairs. One student starts dribbling from the baseline, trying to get around defender. The other pair starts from the half way line and tries to score over their defender.",
    VideoURL: "https://www.youtube.com/watch?v=poi-aekUi6M"
  },
  {
    ActivityName: "Shell Drill",
    SkillTags: "Defence, Passing",
    Instructions: "Divide teams into 2 teams of 4. One team stands along the baseline. Second team is offence (stands at 3 point line). Team on the baseline pass ball to each other. Once player has passed the ball, they run to guard the player directly horizontally across from them. Once all players on the baseline have passed the ball and run into positions, players on the 3 pt line pass the ball to each other, when it gets to the first player they play 4 x 4.",
    VideoURL: "https://www.youtube.com/watch?v=mKhBhkVXIjI"
  },
  {
    ActivityName: "Freeze Tag",
    SkillTags: "Defence, Dribbling, Footwork, Shooting",
    Instructions: "Divide teams into 2 teams of 4. One team wears pinnies. Team with Pinnies needs to tag other team. Once team members have been tagged they need to stop and do 5 star jumps and then can continue. At the end of the 2 mins, teams swap over.",
    VideoURL: "https://www.youtube.com/watch?v=89PdzbwKCVg"
  },
  {
    ActivityName: "Footwork Mechanics",
    SkillTags: "Dribbling, Footwork",
    Instructions: "Using tension bands put team into pairs. Each player uses their bands to provide tension whilst team member dribbles up the court: 1. Jump Stop 2. Skate Stop 3. Jab Step 4. In and Out step",
    VideoURL: ""
  },
  {
    ActivityName: "SIGMA",
    SkillTags: "Passing, Shooting",
    Instructions: "Team stands in a circle. Have one less ball than team members. Each team member bounce passes ball to their right. One team member is nominated to call out 'SIGMA'. Upon calling out SIGMA team proceeds to hoop to shoot. First player to score gets to call out SIGMA next.",
    VideoURL: ""
  },
  {
    ActivityName: "Free Throw Golf",
    SkillTags: "Defence, Footwork, Passing, Shooting",
    Instructions: "Implementation of free throw strategy | Shooting Mechanics| Positioning along the key. Divide players into two teams (use pinnies). 1st Player starts at the Free throw line, shoots for two |rotates with next player. Coach to stand below net for rebound basket. If the player misses a shot team gets one point. Re-inforce shooting mechanics, positioning of hands, elbows tucked in, wide stance and 'wrist snap' /'cookie jar'",
    VideoURL: ""
  },
  {
    ActivityName: "2v1 (1 pass max)",
    SkillTags: "Defence, Passing, Shooting",
    Instructions: "Coach to stand at the free throw line. Line up 3 rows of players at the baseline. Two outer rows will be offensive team. Middle row is the defensive team. Two outer players pass the ball to each other with defensive player in the middle. Offense play until they score or defense blocks the shot.",
    VideoURL: ""
  },
  {
    ActivityName: "Gates Dribbling",
    SkillTags: "Defence, Dribbling, Footwork, Passing, Shooting",
    Instructions: "Using cones create double as many gates as players. Ask players to dribble through as many gates as they can. Ensure gates are in different directions and ensure they look up and keep their eyes forward. Encourage retreat and stepping forward.",
    VideoURL: "https://www.youtube.com/watch?v=7PVlahzbgBw"
  },
  {
    ActivityName: "Pass the Rock",
    SkillTags: "Dribbling, Passing",
    Instructions: "Divide players into two teams. One team has singlets. Place 6 cones along 3 point line. 6 players mirror the players at the 3 point line and stand in front of them with balls. Players will throw as many passes around the circle as they can. Throw as many passes in the minute and then try and beat their previous record. Repeat 3 times.",
    VideoURL: "https://www.youtube.com/watch?v=k9DtRH442uA"
  },
  {
    ActivityName: "Diamond Passing",
    SkillTags: "Dribbling, Footwork, Passing",
    Instructions: "Practise pivots and jumpstops. Place 4 cones in a diamond shape and one in the middle. One player dribbles to the centre of the cone -> Jumpstops -> Passes to the right. Once the player has passed the ball to the right they line up behind the line they just passed to. Set the timer and see how long it takes to go through a full rotation of all players.",
    VideoURL: ""
  },
  {
    ActivityName: "Space Treasure",
    SkillTags: "Defence, Dribbling, Passing, Shooting",
    Instructions: "Divide players into teams of 3. All basketballs to sit in the middle of the cones. Send one player to the middle to collect a basketball and dribble it back to the group. Throw to your players your player must throw the ball in the air, clap and catch it and then pass to the next player. Once all your players have caught and catched the ball, then send your player out to get another ball. Once all the balls have been collected then you can steal other planets balls. If the planets tag you then you must return the ball to where you stole it from.",
    VideoURL: ""
  },
  {
    ActivityName: "Circle Passing",
    SkillTags: "Passing, Shooting",
    Instructions: "Players line up along the 3-pt line. One player faces all players. Player in the middle passes the ball to each player along the 3-pt line quickly. When the last player throws the ball back to the middle player they turn and shoot a layup.",
    VideoURL: ""
  },
  {
    ActivityName: "Red Light, Green Light",
    SkillTags: "Dribbling, Footwork, Warm-up",
    Instructions: "All group Play sideline to sideline. Coach to yell out Green, Yellow, Red light. Green light – Dribble towards each other fast. Yellow light – Slow down dribble. Red light – Jump stop & Stand in Triple Threat position. Make up new colour – i.e Orange = 5 star jumps",
    VideoURL: "https://www.youtube.com/watch?v=x3F_wmmwlm0"
  },
  {
    ActivityName: "Figure 8 Dribbling",
    SkillTags: "Dribbling",
    Instructions: "Players spread out with a ball each. Dribble the ball in a figure 8 pattern between their legs. Focus on ball control and keeping eyes up. Progress to faster speeds as control improves.",
    VideoURL: "https://www.youtube.com/watch?v=E6uGcVWVACE"
  },
  {
    ActivityName: "Partner Passing",
    SkillTags: "Passing",
    Instructions: "Players pair up and stand 10-15 feet apart. Practice chest passes, bounce passes, and overhead passes. 10 repetitions of each type. Focus on proper form and accuracy.",
    VideoURL: "https://www.youtube.com/watch?v=TChrNXAWF5E"
  },
  {
    ActivityName: "Spot Shooting",
    SkillTags: "Shooting",
    Instructions: "Set up 5 spots around the key. Players take 5 shots from each spot. Keep track of makes. Rotate through all players. Focus on proper shooting form: BEEF (Balance, Eyes, Elbow, Follow-through).",
    VideoURL: "https://www.youtube.com/watch?v=BloEnNbz4qk"
  },
  {
    ActivityName: "Dribble Tag",
    SkillTags: "Dribbling",
    Instructions: "All players dribble in a defined area. Each player tries to knock others' balls away while maintaining their own dribble. Last player maintaining their dribble wins. Reset and play multiple rounds.",
    VideoURL: "https://www.youtube.com/watch?v=NxXNxnZnxHE"
  },
  {
    ActivityName: "Pass and Cut",
    SkillTags: "Passing",
    Instructions: "Form three lines: one at top of key, two on wings. Pass to wing, cut to basket, receive pass for layup. Rotate positions. Focus on timing of cut and crisp passes.",
    VideoURL: ""
  },
  {
    ActivityName: "Form Shooting",
    SkillTags: "Shooting",
    Instructions: "Players start close to basket (2-3 feet). Focus on perfect form: knees bent, elbow in, follow through. Make 5 shots before stepping back. Continue until free throw line.",
    VideoURL: "https://www.youtube.com/watch?v=FBqr2HT_DAI"
  },
  {
    ActivityName: "Two-Ball Dribbling",
    SkillTags: "Dribbling",
    Instructions: "Players use two balls simultaneously. Practice: alternating dribbles, same time dribbles, high/low combinations. Start stationary, progress to walking, then jogging.",
    VideoURL: "https://www.youtube.com/watch?v=g5DKLwJ2VyQ"
  },
  {
    ActivityName: "Rapid Fire Passing",
    SkillTags: "Passing",
    Instructions: "Players form a circle with one in middle. Middle player rapidly passes to each player in circle, receiving pass back before moving to next player. Focus on quick reactions and accurate passes.",
    VideoURL: ""
  },
  {
    ActivityName: "Around the World",
    SkillTags: "Shooting",
    Instructions: "Set up 8 shooting spots in a circle around the basket. Players must make a shot from each spot to advance. Miss and stay or go back to previous spot. First player to complete the circle wins.",
    VideoURL: "https://www.youtube.com/watch?v=hMJPct7IN_E"
  },
  {
    ActivityName: "Crossover Series",
    SkillTags: "Dribbling",
    Instructions: "Practice different crossover moves: regular crossover, between legs, behind back. Do each move 10 times stationary, then while walking, then while jogging. Focus on ball control and protection.",
    VideoURL: "https://www.youtube.com/watch?v=zQZ_WUO2MVw"
  },
  {
    ActivityName: "3-Man Weave",
    SkillTags: "Passing",
    Instructions: "Three players weave down court using passing only (no dribbling). Finish with layup. Focus on proper spacing, timing of passes, and running lanes. Switch positions on way back.",
    VideoURL: "https://www.youtube.com/watch?v=ZWt_xZZxD-w"
  },
  {
    ActivityName: "Free Throw Practice",
    SkillTags: "Shooting",
    Instructions: "Players shoot 10 free throws, tracking makes. Between shots, practice routine: 2 dribbles, spin ball, bend knees, shoot. Focus on consistency and routine development.",
    VideoURL: "https://www.youtube.com/watch?v=BKIOqbx3sbU"
  },
  {
    ActivityName: "Spider Dribbling",
    SkillTags: "Dribbling",
    Instructions: "Set up 6 cones in zigzag pattern. Players dribble through cones using crossovers. Focus on controlled speed and tight turns. Progress to non-dominant hand only.",
    VideoURL: ""
  },
  {
    ActivityName: "Give and Go",
    SkillTags: "Passing",
    Instructions: "Two lines: one at top, one at wing. Pass to wing, cut to basket, receive pass for layup. Wing becomes new passer. Focus on proper passing angles and timing of cut.",
    VideoURL: "https://www.youtube.com/watch?v=R8tBRGXWxWM"
  },
  {
    ActivityName: "Beat the Pro",
    SkillTags: "Shooting",
    Instructions: "One shooter vs one rebounder. Shooter must make shot before rebounder can get ball and make layup. Rotate positions after each round. Develops quick release and pressure shooting.",
    VideoURL: ""
  }
];

export default function ActivityManagement() {
  const [activities, setActivities] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [isResetting, setIsResetting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [editingActivity, setEditingActivity] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedActivities, setSelectedActivities] = useState([]);

  useEffect(() => {
    loadActivities();
  }, []);

  const loadActivities = async () => {
    try {
      const loadedActivities = await getActivities();
      setActivities(loadedActivities);
      setLoading(false);
    } catch (error) {
      console.error('Error loading activities:', error);
      setLoading(false);
    }
  };

  const handleAddActivity = async (newActivity) => {
    try {
      await addActivity(newActivity);
      setShowAddForm(false);
      loadActivities();
    } catch (error) {
      console.error('Error adding activity:', error);
      alert('Failed to add activity: ' + error.message);
    }
  };

  const handleEditActivity = async (updatedActivity) => {
    try {
      await updateActivity(editingActivity.id, updatedActivity);
      setEditingActivity(null);
      loadActivities();
    } catch (error) {
      console.error('Error updating activity:', error);
      alert('Failed to update activity: ' + error.message);
    }
  };

  const handleDeleteActivity = async (activityId) => {
    if (!confirm('Are you sure you want to delete this activity?')) {
      return;
    }
    try {
      await deleteActivity(activityId);
      loadActivities();
    } catch (error) {
      console.error('Error deleting activity:', error);
      alert('Failed to delete activity: ' + error.message);
    }
  };

  const handleReset = async () => {
    if (!confirm('This will delete all existing activities and replace them with the original ones. Are you sure?')) {
      return;
    }

    setIsResetting(true);
    try {
      await clearAllActivities();
      
      for (const activity of originalActivities) {
        await addActivity(activity);
      }
      
      loadActivities();
      alert('Activities have been reset successfully!');
    } catch (error) {
      console.error('Error resetting activities:', error);
      alert('Failed to reset activities: ' + error.message);
    } finally {
      setIsResetting(false);
    }
  };

  const handleAddToSession = (activity) => {
    if (selectedActivities.length >= 3) {
      alert('You can only select up to 3 activities');
      return;
    }
    setSelectedActivities([...selectedActivities, activity]);
  };

  const handleRemoveFromSession = (activity) => {
    setSelectedActivities(selectedActivities.filter(a => a.id !== activity.id));
  };

  if (loading) {
    return <div className="flex justify-center items-center h-64">Loading...</div>;
  }

  return (
    <>
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-between items-start gap-8">
          {/* Left side - Activity Library */}
          <div className="flex-1">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-900">Activity Library</h2>
              <div className="space-x-4">
                <button
                  onClick={() => setShowAddForm(true)}
                  className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                >
                  Add New Activity
                </button>
                <button
                  onClick={handleReset}
                  className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                  disabled={isResetting}
                >
                  Reset Activities
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {activities.map(activity => (
                <div 
                  key={activity.id} 
                  className="bg-white rounded-lg shadow-md p-6 flex flex-col"
                >
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg mb-2">{activity.ActivityName}</h3>
                    <div className="flex flex-wrap gap-2 mb-3">
                      {activity.SkillTags.split(',').map((tag, index) => (
                        <span
                          key={index}
                          className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                        >
                          {tag.trim()}
                        </span>
                      ))}
                    </div>
                    <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                      {activity.Instructions}
                    </p>
                  </div>
                  
                  <div className="space-y-3 mt-auto">
                    {activity.VideoURL && (
                      <button 
                        onClick={() => setSelectedVideo(activity.VideoURL)}
                        className="text-blue-600 hover:text-blue-800 text-sm flex items-center gap-2"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Watch Video
                      </button>
                    )}
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleAddToSession(activity)}
                        className="flex-1 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm"
                      >
                        Add to Session
                      </button>
                      <button
                        onClick={() => setEditingActivity(activity)}
                        className="p-2 text-blue-600 hover:text-blue-800"
                        title="Edit Activity"
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                      <button
                        onClick={() => handleDeleteActivity(activity.id)}
                        className="p-2 text-red-600 hover:text-red-800"
                        title="Delete Activity"
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right side - Selected Activities */}
          <div className="w-80">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Selected Activities</h2>
            {selectedActivities.length === 0 ? (
              <p className="text-gray-500">No activities selected yet</p>
            ) : (
              <div className="space-y-4">
                {selectedActivities.map(activity => (
                  <div 
                    key={activity.id}
                    className="bg-white rounded-lg shadow-md p-4"
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-medium">{activity.ActivityName}</h3>
                        <div className="flex flex-wrap gap-1 mt-1">
                          {activity.SkillTags.split(',').map((tag, index) => (
                            <span
                              key={index}
                              className="bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded"
                            >
                              {tag.trim()}
                            </span>
                          ))}
                        </div>
                      </div>
                      <button
                        onClick={() => handleRemoveFromSession(activity)}
                        className="text-red-500 hover:text-red-700"
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <Modal isOpen={showAddForm} onClose={() => setShowAddForm(false)}>
          <AddActivityForm
            onSubmit={handleAddActivity}
            onCancel={() => setShowAddForm(false)}
          />
        </Modal>

        <Modal isOpen={editingActivity !== null} onClose={() => setEditingActivity(null)}>
          <AddActivityForm
            initialActivity={editingActivity}
            onSubmit={handleEditActivity}
            onCancel={() => setEditingActivity(null)}
          />
        </Modal>

        <VideoModal
          isOpen={selectedVideo !== null}
          videoUrl={selectedVideo}
          onClose={() => setSelectedVideo(null)}
        />
      </div>
    </>
  );
} 